<calao-iframe [src]="url" [hideLoader]="hideLoader"></calao-iframe>